import React, { Fragment } from 'react';
const baseUrl = process.env.STATIC_BASE_URL || '//static.technogramsolutions.com',
    serviceProtocol = process.env.SERVICE_PROTOCOL || 'http';

const HotelReview = (props) => {
    const {
        hotelReview = '', hotelRating = ''
    } = props;
    let star = [];
    for (let i = 0; i < Math.trunc(hotelRating); i++) {
        star.push(<span>
            <img src={`${serviceProtocol}:${baseUrl}/hotel/star.png`} width='15' className="fill-star" style={{
                width: '15px',
                marginRight: '2px'
            }} />
        </span>);
    }
    for (let i = 0; i < 5 - hotelRating; i++) {
        star.push(<span>
            <img src={`${serviceProtocol}:${baseUrl}/hotel/starline.png`} width='15' className="withoutfill-star" style={{
                width: '15px',
                marginRight: '2px'
            }} />
        </span>);
    }
    return (
        <Fragment>
            {/* <div className="hotelrating">
                <span className="hotelrating__value">{hotelRating == 0 ? `` : props.hotelRating}</span>
            </div> */}
            {star}
            {/* { <span className="hoteldetails__rightbox--rating--text">{ratingMap[props.hotelRating]}</span> } */}
            {/* <span className="review__value">{hotelReview} Reviews </span> */}
        </Fragment>
    );
}

export default HotelReview;
